export const LOCAL = 'local';
export const DEV = 'DEV';
export const BETA = 'beta';
export const PROD = 'production';

// PRODUCT and WRITE_MODE are window globals
// they are defined in server/views/index.html with values from server/routes/client.js

export const READ_ONLY = 'read-only';

export const checkMode = () => WRITE_MODE.trim().toLowerCase();

export const IS_READ_ONLY = checkMode() === READ_ONLY;
